import {SessionQuestion} from '@cp/model';
import isSessionQuestionAnswered from './isSessionQuestionAnswered';

/**
 * Find the index of the first unanswered question
 * @param questions - The questions to search through
 * @returns The index of the first unanswered question
 */
export default function findIndexUnanswerQuestion(questions: SessionQuestion[]) {
  return questions.findIndex((question) => !isSessionQuestionAnswered(question));
}
